/* lightbox-gallery.js
 * Generic gallery lightbox for links like:
 * <a href="FULL_IMAGE_URL" data-lightbox="gallery" data-alt="...">
 *
 * Features:
 * - Opens on click
 * - Close via X, ESC, clicking backdrop, OR clicking empty space around image
 * - Next/Prev arrows
 * - Arrow key navigation
 * - Keeps navigation within the same .gallery-masonry__grid
 */

(() => {
    "use strict";

    const LINK_SELECTOR = 'a[data-lightbox="gallery"]';

    // Build one reusable modal
    const modal = document.createElement("div");
    modal.className = "lightbox";
    modal.innerHTML = `
    <div class="lightbox__backdrop" data-lightbox-close="1"></div>
    <div class="lightbox__panel" role="dialog" aria-modal="true" aria-label="Image preview">
      <button class="lightbox__close" type="button" aria-label="Close" data-lightbox-close="1">×</button>

      <button class="lightbox__nav lightbox__prev" type="button" aria-label="Previous">‹</button>
      <img class="lightbox__img" alt="">
      <button class="lightbox__nav lightbox__next" type="button" aria-label="Next">›</button>
    </div>
  `;

    // Append after DOM is ready
    document.addEventListener("DOMContentLoaded", () => {
        document.body.appendChild(modal);
    });

    const $ = (sel) => modal.querySelector(sel);

    let links = [];
    let index = -1;
    let lastFocus = null;

    function getLinksInSameGrid(clickedLink) {
        const grid = clickedLink.closest(".gallery-masonry__grid");
        if (grid) return Array.from(grid.querySelectorAll(LINK_SELECTOR));
        return Array.from(document.querySelectorAll(LINK_SELECTOR));
    }

    function setNavDisabled() {
        const prev = $(".lightbox__prev");
        const next = $(".lightbox__next");
        if (!prev || !next) return;

        prev.disabled = index <= 0;
        next.disabled = index >= links.length - 1;
    }

    function openAt(i) {
        if (!links[i]) return;

        index = i;
        const a = links[index];

        const src = a.getAttribute("href");
        const alt =
            a.getAttribute("data-alt") ||
            (a.querySelector("img") ? a.querySelector("img").getAttribute("alt") : "") ||
            "";

        const img = $(".lightbox__img");
        if (img) {
            img.src = src;
            img.alt = alt;
        }

        modal.classList.add("is-open");
        document.documentElement.classList.add("lightbox-open");

        setNavDisabled();

        const close = $(".lightbox__close");
        if (close) close.focus();
    }

    function closeLightbox() {
        modal.classList.remove("is-open");
        document.documentElement.classList.remove("lightbox-open");

        const img = $(".lightbox__img");
        if (img) img.src = "";

        if (lastFocus && typeof lastFocus.focus === "function") {
            lastFocus.focus();
        }
    }

    function next() {
        openAt(Math.min(index + 1, links.length - 1));
    }

    function prev() {
        openAt(Math.max(index - 1, 0));
    }

    // OPEN: click any gallery link
    document.addEventListener("click", (e) => {
        const a = e.target.closest(LINK_SELECTOR);
        if (!a) return;

        e.preventDefault();

        lastFocus = document.activeElement;
        links = getLinksInSameGrid(a);

        const i = links.indexOf(a);
        openAt(i);
    });

    // CLOSE: click backdrop OR click empty panel space (not the image / controls)
    document.addEventListener("click", (e) => {
        if (!modal.classList.contains("is-open")) return;

        // Any element explicitly marked to close
        const closeTrigger = e.target.closest("[data-lightbox-close='1']");
        if (closeTrigger) {
            e.preventDefault();
            closeLightbox();
            return;
        }

        // Click inside the panel but not on the image or controls => close
        const panel = $(".lightbox__panel");
        const img = $(".lightbox__img");

        if (
            panel &&
            panel.contains(e.target) &&
            img &&
            !img.contains(e.target) &&
            !e.target.closest(".lightbox__nav") &&
            !e.target.closest(".lightbox__close")
        ) {
            closeLightbox();
        }
    });

    // NAV: buttons
    document.addEventListener("click", (e) => {
        if (!modal.classList.contains("is-open")) return;

        if (e.target.closest(".lightbox__next")) {
            e.preventDefault();
            next();
        }

        if (e.target.closest(".lightbox__prev")) {
            e.preventDefault();
            prev();
        }
    });

    // KEYBOARD: ESC / arrows / simple focus trap
    document.addEventListener("keydown", (e) => {
        if (!modal.classList.contains("is-open")) return;

        if (e.key === "Escape") closeLightbox();
        if (e.key === "ArrowRight") next();
        if (e.key === "ArrowLeft") prev();

        // Focus trap
        if (e.key === "Tab") {
            const focusables = modal.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );

            if (!focusables.length) return;

            const first = focusables[0];
            const last = focusables[focusables.length - 1];

            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
    });

    // If the image fails to load, close (optional safety)
    document.addEventListener(
        "error",
        (e) => {
            if (!modal.classList.contains("is-open")) return;
            if (e.target && e.target.classList && e.target.classList.contains("lightbox__img")) {
                closeLightbox();
            }
        },
        true
    );
})();